import isApiError from "@insite/client-framework/Common/isApiError";
import {
    doesNotHaveExpand,
    get,
    patch,
    post,
    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { AddRmaApiParameter, GetOrderApiParameter, GetOrdersApiParameter, UpdateOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import {
    OrderCollectionModel,
    OrderModel,
    RmaModel,
} from "@insite/client-framework/Types/ApiModels";

const ordersUrl = "/api/v1/poolcorp/orders"; // Poolcorp Custom Code

export async function getOrders(parameter: GetOrdersApiParameter): Promise<OrderCollectionModel> {
    // can't send empty status array to API
    if (parameter.status && parameter.status.length === 0) {
        delete parameter.status;
    }

    const orders = await get<OrderCollectionModel>(ordersUrl, parameter);
    orders.orders?.forEach(o => {
        cleanOrder(o);
    });
    return orders;
}

export async function getOrder(parameter: GetOrderApiParameter): Promise<OrderModel> {
    const { orderNumber, ...newParameter } = parameter;

    const order = await get<OrderModel>(`${ordersUrl}/${orderNumber}`, newParameter);
    cleanOrder(order, parameter);
    return order;
}

export async function updateOrder(parameter: UpdateOrderApiParameter) {
    const order = parameter.order;
    const orderNumber = order.erpOrderNumber || order.webOrderNumber;
    const orderModel = await patch<OrderModel>(`${ordersUrl}/${orderNumber}`, order);
    cleanOrder(orderModel);
    return orderModel;
}

export async function addRma(parameter: AddRmaApiParameter): Promise<ServiceResult<RmaModel>> {
    try {
        const rmaModel = await post<RmaModel>(
            `${ordersUrl}/${parameter.rmaModel.orderNumber}/returns`,
            parameter.rmaModel,
        );
        return {
            successful: true,
            result: rmaModel,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

function cleanOrder(orderModel: OrderModel, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
    orderModel.orderDate = new Date(orderModel.orderDate);
    orderModel.id = orderModel.erpOrderNumber || orderModel.webOrderNumber;
    if (doesNotHaveExpand(parameter, "orderLines")) {
        delete orderModel.orderLines;
    }

    if (!orderModel.shipViaDescription) {
        delete orderModel.shipViaDescription;
    }
}
